import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { TenantMsGraphOptions } from 'app/api/models/tenant/TenantMsGraphOptions';

@Component({
  selector: 'app-tenant-ms-graph-edit-form',
  templateUrl: './tenant-ms-graph-edit-form.component.html',
  styleUrls: ['./tenant-ms-graph-edit-form.component.scss'],
})
export class TenantMsGraphEditFormComponent {
  @Input() msGraphOptions: TenantMsGraphOptions | undefined;
  @Input() tenantId: string = '';
  @Output() optionsSubmit = new EventEmitter<TenantMsGraphOptions>();

  Form?: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router
  ) {}

  ngOnInit() {
    this.setUpForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['msGraphOptions'] && !changes['msGraphOptions'].firstChange) {
      this.setUpForm();
    }
  }

  formResult() {
    if (this.Form && !this.Form.valid) {
      this.Form.markAllAsTouched();
      return;
    }

    var result = new TenantMsGraphOptions();
    result.msGraphClientId = this.Form?.value.msGraphClientId;
    result.msGraphClientSecret = this.Form?.value.msGraphClientSecret;
    result.msGraphFromMail = this.Form?.value.msGraphFromMail;
    result.msGraphTenantId = this.Form?.value.msGraphTenantId;
    result.tenantId = this.tenantId;
    result.title = this.Form?.value.title;
    result.useForSystemMails = this.Form?.value.useForSystemMails;
    result.customBusinessCard = this.Form?.value.customBusinessCard;
    result.customBusinessCardContent =
      this.Form?.value.customBusinessCardContent;

    if (this.msGraphOptions) {
      result.id = this.msGraphOptions.id;
    }

    this.optionsSubmit.emit(result);
  }

  setUpForm() {
    this.Form = this.formBuilder.group({
      title: [this.msGraphOptions?.title ?? '', Validators.required],
      msGraphClientId: [
        this.msGraphOptions?.msGraphClientId ?? '',
        Validators.required,
      ],
      msGraphClientSecret: [
        this.msGraphOptions?.msGraphClientSecret ?? '',
        Validators.required,
      ],
      msGraphFromMail: [
        this.msGraphOptions?.msGraphFromMail ?? '',
        Validators.required,
      ],
      msGraphTenantId: [
        this.msGraphOptions?.msGraphTenantId ?? '',
        Validators.required,
      ],
      useForSystemMails: [this.msGraphOptions?.useForSystemMails ?? false],

      customBusinessCard: [this.msGraphOptions?.customBusinessCard ?? false],
      customBusinessCardContent: [
        this.msGraphOptions?.customBusinessCardContent ?? '',
      ],
    });
  }

  cancel() {
    this.router.navigate([`tenants/emails/${this.tenantId}`]);
  }
}
